import styled from 'styled-components'

import { WalletModelShort } from '@root/entities/wallet/ui'
import { useTranslation } from '@root/shared/localization'
import { Separator } from '@root/shared/ui-kit'

import type { WalletModel } from '@root/entities/wallet/atoms'
import type { ClassNameProps } from '@root/shared/react'

type WalletColorPreviewProps = {
  wallet: WalletModel
  color: string
} & ClassNameProps

export const WalletColorPreview: React.FC<WalletColorPreviewProps> = ({
  className,
  color,
  wallet,
}) => {
  const { t } = useTranslation()

  return (
    <Root className={className}>
      <Label>{t('common.example')}</Label>
      <Separator />
      <WalletContainer>
        <WalletModelShort colorOverride={color} wallet={wallet} size="sm" />
      </WalletContainer>
    </Root>
  )
}

const Root = styled.div`
  background: var(--backgroundA-1);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 16px;

  border-radius: 12px;
  background:
    radial-gradient(
      610% 95% at -50% 50%,
      transparent 100%,
      var(--backgroundA-5) 0%
    ),
    var(--backgroundA-1);

  margin-bottom: 16px;
`

const Label = styled.div`
  font-weight: 500;
  font-size: 12px;
  color: var(--text-9);
  padding-block: 16px;
  text-align: center;
`

const WalletContainer = styled.div`
  padding-block: 16px;
  display: grid;
  justify-content: center;
`
